import { PmErrorState } from "../components/utils/PmErrorState";

export const NotFound = () => {
  return (
    <PmErrorState
      variant="not_found"
      layout="page"
      primaryTo="/"
    />
  );
};
